
import { Card, Box, Button, Divider, InlineGrid, Icon, InlineStack, Image, Page, ProgressBar, Spinner, Text, TextField, BlockStack, Checkbox, RadioButton, ButtonGroup, Avatar, Select, Collapsible, Banner, Autocomplete, Tag } from "@shopify/polaris";
import { ArrowLeftIcon, ChevronDownIcon, ChevronUpIcon, ClockIcon, EditIcon, LogoInstagramIcon, LogoTiktokIcon, LogoYoutubeIcon, PlusIcon } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
// import { Instagram, Tiktok, Youtube } from "../../utils";
// import ChooseASubscriptionPanel from "../ChooseASubscriptionPanel";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import AppLayout from "../components/layout";
import ChooseASubscriptionPanel from "../components/ChooseASubscriptionPanel";
import { addDoc, collection, doc, setDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

export const countryCodes = [
  {
    "id": 148838,
    "name": "United States",
    "title": "United States"
  },
  {
    "id": 2202162,
    "name": "France",
    "title": "France"
  },
  {
    "id": 60189,
    "name": "Russia",
    "title": "Russia"
  },
  {
    "id": 1428125,
    "name": "Canada",
    "title": "Canada"
  },
  {
    "id": 1311341,
    "name": "Spain",
    "title": "Spain"
  },
  {
    "id": 62149,
    "name": "United Kingdom",
    "title": "United Kingdom"
  },
  {
    "id": 59470,
    "name": "Brazil",
    "title": "Brazil"
  },
  {
    "id": 114686,
    "name": "Mexico",
    "title": "Mexico"
  },
  {
    "id": 51477,
    "name": "Germany",
    "title": "Germany"
  },
  {
    "id": 365331,
    "name": "Italy",
    "title": "Italy"
  },
  {
    "id": 174737,
    "name": "Turkey",
    "title": "Turkey"
  },
  {
    "id": 304716,
    "name": "India",
    "title": "India"
  },
]

export default function Onboarding() {
  const { user, uploadFile, noUser, createOrUpdateUser, subscription, auth, emailSequences, db } = usePartnerUp()
  const navigate = useNavigate()
  const [step, setStep] = useState(0)
  const [uploadLoading, setUploadLoading] = useState(null)
  const [localFilters, setLocalFilters] = useState({
    ageGroups: [],
    genders: [],
    countries: []
  })

  console.log('emailSequences', emailSequences)

  const [filters, setFilters] = useState({
    platform: 'instagram',
    gender: 'Any',
    minFollowers: '10000',
    maxFollowers: '50000',
    keywords: ''
  })

  if (user) {
    navigate('/')
  }

  const [localUser, setLocalUser] = useState({
    name: user?.displayName || auth.currentUser?.displayName,
  })

  const [logoFile, setLogoFile] = useState(null)

  console.log('user id', user?.id, user)

  useEffect(() => {
    if (logoFile) {
      setUploadLoading(1)
      uploadFile(logoFile, 'logo').then(url => {
        setUploadLoading(null)
        console.log('url', url)
      }).catch(e => {
        setUploadLoading(null)
        console.error(e)
        // setToast({ content: 'Error uploading. Please try again.', isError: true })
      })
    }
  }, [logoFile])

  async function saveBaseSearch() {
    await setDoc(doc(db, 'usersV2', user.id), {
      filters
    }, { merge: true })
  }

  console.log('filters are', filters)

  const steps = [
    (
      <BlockStack gap="500">
        <InlineStack align="space-between">
          <div className="fadeInDown">
            <BlockStack gap="100">
              <Text variant="headingMd">Hi There</Text>
              <Text variant="headingXl">Welcome to PartnerUp!</Text>
              <Text variant="bodyLg">Let's Create Your Account</Text>
            </BlockStack>
          </div>
          <img src="https://assets.codepen.io/6060109/prup-anim.gif" style={{ width: 'auto', height: '100px' }} />
        </InlineStack>
        <div style={{ width: '100%' }}>
          <ProgressBar progress={0} />
        </div>
        <InlineStack align="start">
          <div className="fadeInDown" style={{ animationDelay: '.5s' }}>
            <Button primary size="large" onClick={() => setStep(1)}>⚡Get Started</Button>
          </div>
        </InlineStack>
      </BlockStack>
    ),
    (
      <BlockStack gap="500">
        <div className="fadeInDown">
          <BlockStack gap="100">
            <Text variant="headingMd">First Off,</Text>
            <Text variant="headingXl">About You</Text>
            <Text variant="bodyLg">Just some basic details</Text>
          </BlockStack>
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar progress={25} />
        </div>
        <div className="fadeInDown" key="firstoff-content" style={{ animationDelay: '.5s' }}>
          <InlineGrid columns="1fr 2fr 1fr">
            <Box />
            <BlockStack gap="300">
              <div style={{ height: '500px' }}>
                <BlockStack gap="300">
                  <InlineGrid columns="1" gap="300">
                    <Card>
                      <BlockStack gap="300">
                        <InlineStack align="space-between">
                          <Text variant="headingMd">Your Name</Text>
                        </InlineStack>
                        <Divider />
                        <TextField value={localUser?.name} onChange={v => setLocalUser({ ...localUser, name: v })} />
                      </BlockStack>
                    </Card>
                  </InlineGrid>
                  <Card>
                    <BlockStack gap="300">
                      <InlineStack align="space-between">
                        <Text variant="headingMd">Company Name</Text>
                      </InlineStack>
                      <Divider />
                      <TextField value={localUser?.brand} onChange={v => setLocalUser({ ...localUser, brand: v })} />
                    </BlockStack>
                  </Card>
                  <Card>
                    <BlockStack gap="300">
                      <InlineStack align="space-between">
                        <Text variant="headingMd">How Did You Find Us?</Text>
                      </InlineStack>
                      <Divider />
                      <InlineStack blockAlign="center" align="start">
                        <RadioButton checked={localUser?.source === 'google'} onChange={v => setLocalUser({ ...localUser, source: 'google' })} />
                        <Text variant="headingMd">Google</Text>
                      </InlineStack>
                      <InlineStack blockAlign="center" align="start">
                        <RadioButton checked={localUser?.source === 'youtube'} onChange={v => setLocalUser({ ...localUser, source: 'youtube' })} />
                        <Text variant="headingMd">YouTube</Text>
                      </InlineStack>
                      <InlineStack blockAlign="center" align="start">
                        <RadioButton checked={localUser?.source === 'productHunt'} onChange={v => setLocalUser({ ...localUser, source: 'productHunt' })} />
                        <Text variant="headingMd">Product Hunt</Text>
                      </InlineStack>
                      <InlineStack blockAlign="center" align="start">
                        <RadioButton checked={localUser?.source === 'referral'} onChange={v => setLocalUser({ ...localUser, source: 'referral' })} />
                        <Text variant="headingMd">Referral</Text>
                      </InlineStack>
                      <InlineStack blockAlign="center" align="start">
                        <RadioButton checked={localUser?.source === 'other'} onChange={v => setLocalUser({ ...localUser, source: 'other' })} />
                        <Text variant="headingMd">Other</Text>
                      </InlineStack>
                    </BlockStack>
                  </Card>
                  <InlineGrid columns="1" gap="500">
                  </InlineGrid>
                </BlockStack>
              </div>
              <InlineStack align="end">
                <Button primary disabled={
                  !localUser?.name || !localUser?.brand || !localUser?.source
                } onClick={async () => {
                  setStep(3)
                }} variant="primary" size="large">Looks Good!</Button>
              </InlineStack>
            </BlockStack>
          </InlineGrid>
        </div>
      </BlockStack>
    ),
    (
      <BlockStack gap="500">
        <div key="sourcing" className="fadeInDown">
          <BlockStack gap="100">
            <Text variant="headingMd">Sourcing</Text>
            <Text variant="headingXl">What Kind of Influencers Are You Looking For?</Text>
            <Text variant="bodyLg">You can choose multiple, and change this later!</Text>
          </BlockStack>
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar progress={50} />
        </div>
        <div className="fadeInDown" key="sourcing-content" style={{ animationDelay: '.5s' }}>
          <InlineGrid columns="1fr 2fr 1fr">
            <Box />
            <BlockStack gap="300">
              <InlineGrid gap="300" columns="3">
                <Card>
                  <InlineStack blockAlign="center">
                    <RadioButton checked={filters?.platform === 'instagram'} onChange={v => setFilters({ ...filters, platform: 'instagram' })} />
                    <Icon source={LogoInstagramIcon} />
                    <Text variant="headingMd">Instagram</Text>
                  </InlineStack>
                </Card>
                <Card>
                  <InlineStack gap="100" blockAlign="center">
                    <RadioButton checked={filters?.platform === 'tiktok'} onChange={v => setFilters({ ...filters, platform: 'tiktok' })} />
                    <InlineStack>
                      <Icon source={LogoTiktokIcon} />
                    </InlineStack>
                    <Text variant="headingMd">Tiktok</Text>
                  </InlineStack>
                </Card>
                <Card>
                  <InlineStack blockAlign="center">
                    <RadioButton checked={filters?.platform === 'youtube'} onChange={v => setFilters({ ...filters, platform: 'youtube' })} />
                    <InlineStack>
                      <Icon source={LogoYoutubeIcon} />
                    </InlineStack>
                    <Text variant="headingMd">YouTube</Text>
                  </InlineStack>
                </Card>
              </InlineGrid>
              <Card>
                <Select label="Gender" options={[
                  { value: 'Male', label: 'Male' },
                  { value: 'Female', label: 'Female' },
                  { value: 'Any', label: 'Any' },
                ]} value={filters?.gender} onChange={v => setFilters({ ...filters, gender: v })} />
              </Card>
              <Card>
                <BlockStack gap="200">
                  <Text>Followers</Text>
                  <InlineGrid columns="1fr 1fr" gap="100">
                    <Select label="From" labelInline options={[
                      { value: 'Any', label: 'Any' },
                      { value: '1000', label: '1,000' },
                      { value: '10000', label: '10,000' },
                      { value: '50000', label: '50,000' },
                      { value: '100000', label: '100,000' },
                      { value: '500000', label: '500,000' },
                      { value: '1000000', label: '1,000,000' },
                    ]} value={filters?.minFollowers} onChange={v => setFilters({ ...filters, minFollowers: v })} />
                    <Select label="To" labelInline options={[
                      { value: 'Any', label: 'Any' },
                      { value: '10000', label: '10,000' },
                      { value: '50000', label: '50,000' },
                      { value: '100000', label: '100,000' },
                      { value: '500000', label: '500,000' },
                      { value: '1000000', label: '1,000,000' },
                      { value: '5000000', label: '5,000,000' },
                    ]} value={filters?.maxFollowers} onChange={v => setFilters({ ...filters, maxFollowers: v })} />
                  </InlineGrid>
                </BlockStack>
              </Card>
              <Card>
                <TextField label="Keyword" placeholder="Ex. Skincare" helpText="Just the first one to try" value={filters?.keywords} onChange={v => setFilters({ ...filters, keywords: v })} />
              </Card>
              <InlineStack align="end">
                <ButtonGroup>
                  <Button plain onClick={() => setStep(step - 1)}>Back</Button>
                  <Button primary onClick={async () => {
                    setLocalUser({
                      ...localUser,
                      filters
                    })
                    setStep(step + 1)
                  }}>Next</Button>
                </ButtonGroup>
              </InlineStack>
            </BlockStack>
          </InlineGrid>
        </div>
      </BlockStack>
    ),
    (
      <BlockStack gap="500">
        <div key="content" className="fadeInDown">
          <BlockStack gap="100">
            <Text variant="headingMd">Qualified Followers</Text>
            <Text variant="headingXl">Who are your target customers?</Text>
            <Text variant="bodyLg">We will calculate this for you on every profile</Text>
          </BlockStack>
        </div>
        <div style={{ width: '100%' }}>
          <ProgressBar progress={75} />
        </div>
        <div key="content-content" className="fadeInDown" style={{ animationDelay: '.5s' }}>
          <InlineGrid columns="1fr 5fr 1fr">
            <Box />
            <BlockStack gap="500">
              <BlockStack gap="500">
                <Autocomplete
                  allowMultiple
                  onSelect={(value) => {
                    const newValue = value.pop()
                    setLocalFilters({
                      ...localFilters,
                      ageGroups: [...localFilters.ageGroups, newValue]
                    })
                  }}
                  label="Ages"
                  options={[
                    { label: '13-17', value: '13-17' },
                    { label: '18-24', value: '18-24' },
                    { label: '25-34', value: '25-34' },
                    { label: '35-44', value: '35-44' },
                    { label: '45-64', value: '45-64' },
                    { label: '65+', value: '65-' }
                  ].filter(i => !(localFilters.ageGroups?.includes(i.value) === true))}
                  selected={localFilters.ageGroups || []}
                  textField={
                    <Autocomplete.TextField
                      placeholder={localFilters?.ageGroups?.length > 5 ? '' : localFilters?.ageGroups?.length > 0 ? "Add Age" : "Any"}
                      label="Ages"
                      value={''}
                      autoComplete="off"
                      verticalContent={
                        localFilters?.ageGroups?.length > 0 ? (
                          <InlineStack gap="3" align="start">
                            {
                              localFilters.ageGroups?.map(age => {
                                return (
                                  <Tag key={age} onRemove={
                                    () => {
                                      setLocalFilters({
                                        ...localFilters,
                                        ageGroups: localFilters.ageGroups.filter(i => i !== age)
                                      })
                                    }
                                  }>{age}
                                  </Tag>
                                )
                              })
                            }
                          </InlineStack>
                        ) : null
                      }
                    />
                  }
                />
                <Autocomplete
                  allowMultiple
                  onSelect={(value) => {
                    const newValue = value.pop()
                    setLocalFilters({
                      ...localFilters,
                      genders: [...localFilters.genders, newValue]
                    })
                  }}
                  label="Gender"
                  options={[
                    { label: 'Male', value: 'MALE' },
                    { label: 'Female', value: 'FEMALE' },
                  ].filter(i => !(localFilters.genders?.includes(i.value) === true))}
                  selected={localFilters.genders || []}
                  textField={
                    <Autocomplete.TextField
                      placeholder={localFilters?.genders?.length > 1 ? '' : localFilters?.genders?.length > 0 ? "Add Gender" : "Any"}
                      label="Genders"
                      value={''}
                      autoComplete="off"
                      verticalContent={
                        localFilters?.genders?.length > 0 ? (
                          <InlineStack gap="3" align="start">
                            {
                              localFilters?.genders?.map(gender => {
                                return (
                                  <Tag onRemove={
                                    () => {
                                      setLocalFilters({
                                        ...localFilters,
                                        genders: localFilters.genders.filter(i => i !== gender)
                                      })
                                    }}>
                                    {gender}
                                  </Tag>
                                )
                              })
                            }
                          </InlineStack>
                        ) : null
                      }
                    />
                  }
                />
                <Autocomplete
                  allowMultiple
                  onSelect={(value) => {
                    const newValue = value.pop()
                    setLocalFilters({
                      ...localFilters,
                      countries: [...localFilters.countries, newValue]
                    })
                  }}
                  label="Countries"
                  options={countryCodes?.map(c => {
                    return {
                      label: c.name,
                      value: c.name
                    }
                  }).filter(i => !(localFilters.countries?.includes(i.value) === true))}
                  selected={localFilters.countries || []}
                  textField={
                    <Autocomplete.TextField
                      placeholder={localFilters?.countries?.length > 0 ? "Add Country" : "Any"}
                      label="Countries"
                      value={''}
                      autoComplete="off"
                      verticalContent={
                        localFilters?.countries?.length > 0 ? (
                          <InlineStack gap="3" align="start">
                            {
                              localFilters?.countries?.map(country => {
                                return (
                                  <Tag onRemove={
                                    () => {
                                      setLocalFilters({
                                        ...localFilters,
                                        countries: localFilters.countries.filter(i => i !== country)
                                      })
                                    }}>
                                    {country}
                                  </Tag>
                                )
                              })
                            }
                          </InlineStack>
                        ) : null
                      }
                    />
                  }
                />
              </BlockStack>
              {
              }
              <InlineStack align="end">
              </InlineStack>
              <InlineStack align="space-between">
                <Button plain onClick={() => setStep(step - 2)}>Back</Button>
                <Button primary onClick={async () => {
                  createOrUpdateUser({ ...localUser, filters: localFilters })
                  setStep(step + 1)
                }}>Next</Button>
              </InlineStack>
            </BlockStack>
          </InlineGrid>
        </div>
      </BlockStack>
    ),
    (
      <BlockStack gap="500">
        <div key="subscribe" className="fadeInDown">
          <BlockStack gap="100">
            <Text variant="headingMd">Let's Find Your Creators!</Text>
            <Text variant="headingXl">Just Choose a Plan</Text>
            <Text variant="bodyLg">Don't Worry, Your Card Won't Be Charged If You Cancel.</Text>
          </BlockStack>
        </div>
        <div key="subscribe-content" style={{ width: '100%' }}>
          <ProgressBar progress={100} />
        </div>
        <div className="fadeInDown" style={{ animationDelay: '.5s' }}>
          <ChooseASubscriptionPanel showHeader={false} />
        </div>
        <InlineStack align="end">
          <Button plain onClick={() => setStep(3)}>Back</Button>
        </InlineStack>
      </BlockStack>
    )
  ]
  return (
    <AppLayout menuDisabled={true}>
      <Box paddingBlockStart="800">
        <Page>
          {steps[step]}
        </Page>
      </Box>
    </AppLayout>
  )
}
